var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialAuthInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#858994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.5H16.25C14.1789 12.5 12.5 14.1789 12.5 16.25V23.75C12.5 25.8211 14.1789 27.5 16.25 27.5H23.75C25.8211 27.5 27.5 25.8211 27.5 23.75V16.25C27.5 14.1789 25.8211 12.5 23.75 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.5267C23.0926 20.1509 22.986 20.7884 22.6953 21.3485C22.4047 21.9086 21.9449 22.3628 21.3812 22.6465C20.8176 22.9302 20.1789 23.0289 19.5559 22.9287C18.9329 22.8285 18.3573 22.5343 17.9112 22.0881C17.465 21.6419 17.1708 21.0664 17.0706 20.4434C16.9703 19.8204 17.0691 19.1817 17.3528 18.618C17.6365 18.0544 18.0907 17.5946 18.6508 17.3039C19.2109 17.0133 19.8483 16.9067 20.4725 16.9992C21.1092 17.0937 21.6987 17.3903 22.1538 17.8455C22.6089 18.3006 22.9056 18.8901 23 19.5267Z",
    stroke: "#858994",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 15.875H24.1325",
    stroke: "#858994",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialAuthInstagram);
export default __webpack_public_path__ + "static/media/icon_social_auth_instagram.af3193921894474bc194d9773f206bf1.svg";
export { ForwardRef as ReactComponent };